import { Component } from '@angular/core';
import { AuthenticationService } from '../../authentication/authentication.service';
import { Constants } from '../../constants/constants';

@Component({
  selector: 'app-navigation-bar',
  templateUrl: './navigation-bar.component.html',
  styleUrls: ['./navigation-bar.component.scss']
})

export class NavigationBarComponent {

  interval: any;
  refreshNeeded: boolean;

  constructor(public authenticationService: AuthenticationService) {
  }

  ngOnInit() {
    this.handleNotificationsTimer();
  }

  handleNotificationsTimer() {
    this.interval = setInterval(() => {
      this.updateNotifications();
    }, Constants.NotificationsRefreshInterval);
  }

  updateNotifications() {
    if (this.authenticationService.isAuthenticated) {
      // A little dirty but it works :-) The toggle of the flag triggers the ngOnChanges for a refresh of the notification components.
      this.refreshNeeded = !this.refreshNeeded;
    }
  }
}
